<template>
  <div class="histroy">
    <div class="histroy_top">
      <strong class="histroy_name">历史搜索</strong><span class="histroy_clear" @click="deletestoreKeys">清除</span>
    </div>
    <div class="histroy_keyWords_wrapper">
      <router-link class="histroy_keyWords" :key="index" :to="{name:'searchResulte',query:{
        keyWord:localHistoryKey

      }}" v-for="(localHistoryKey,index) in histroyKeyWords" >{{localHistoryKey.slice(0,6)}}</router-link>
    </div>
  </div>
</template>
<script type = "text/ecamscript-6">
  export default {
    name:"histroyKeyWords",
    props:['deletestoreKeys'],
    data(){
      return {
        histroyKeyWords:this.$store.getters.getLocalHistoryKeys
      }
    },
    created:function(){
    },
    mounted:function(){
    },
    computed:{


    },
    methods:{

    }
  }
</script>
<style lang="stylus">
  .histroy
    padding:30px 30px 0
    border-radius:10px 10px 0 0
    background:#fff
    .histroy_top
      display:flex
      box-sizing:border-box
      line-height:48px
      justify-content:space-between

      .histroy_name
        font-size:32px
        color:#333
      .histroy_clear
        font-size:26px
        color:#fa6700
    .histroy_keyWords_wrapper
      padding:20px 0 10px
      background:#fff
      .histroy_keyWords
        color:#666
        font-size:24px
        margin-right:15px


</style>



// WEBPACK FOOTER //
// src/components/search/histroyKeyWords.vue